var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbstract6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 86,
    viewBox: "0 0 150 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.4773 79.2252C89.6088 89.9596 126.869 86.3815 138.661 79.2252C150.924 67.1489 111.776 60.4401 99.9852 59.9928C88.1939 59.5455 77.3459 68.4908 83.4773 79.2252Z",
    fill: "#FFE592"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.466509 65.36C3.76807 70.7272 24.0491 72.9635 34.4255 68.9381C40.5569 63.1237 24.5208 48.3638 18.3893 47.4693C12.2578 46.5748 -2.83506 59.9928 0.466509 65.36Z",
    fill: "#FFE592"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.55 27.3423C123.096 34.0513 138.661 32.7095 146.679 24.2114C154.697 16.1606 146.679 1.40082 138.661 0.0590102C130.643 -1.28279 108.003 20.6333 115.55 27.3423Z",
    fill: "#FFE592"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract6);
export default __webpack_public_path__ + "static/media/abstract-6.9729a4b944ece7f608595dec7ed1d2da.svg";
export { ForwardRef as ReactComponent };